import { Component, OnInit } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import * as Services from '@shared/core/services';
import * as State from '@shared/state';

import { ModalViewComponent } from '../modal-view.shared.component';
import { Observable } from 'rxjs';
import { IOrder } from '@shared/state';

@Component({
    selector: 'shared-modal-for-order-types',
    templateUrl: './modal-for-order-types.shared.component.html',
    styleUrls: ['./modal-for-order-types.shared.component.scss']
})
export class ModalForOrderTypesComponent extends ModalViewComponent implements OnInit {
    public orderTypes$: Observable<State.IOrderType>;

    constructor(
        public modalsService: Services.ModalsService,
        public heightAdjustService: Services.HeightAdjustService,
        public controllers: Controllers,
    ) {
        super(modalsService, heightAdjustService, null);
    }

    ngOnInit(): void {
        this.size = 'xsm';

        this.orderTypes$ = this.controllers.onlineOrders.getOrderTypesForLocation$(this.modalData.locationNo);
    }

    public trackBy(orderType: IOrder, index: number): number {
        return orderType?.Id || index;
    }
}
